import { computed, Signal } from "@angular/core";
import { getById, recordForEach, recordSet } from "../../functions/record.function";
import { StoreBatchWeighing } from "../../storage/data-store/model/registrations/store-batch-weighing";
import { StoreBatch } from "../../storage/data-store/model/master-data/store-batch";
import { BatchWeighingViewModel } from "../shared/batch-weighing.viewmodel";
import { getAdjacentBatchWeighingsByBatchNumber, getSortedBatchWeighingsByBatchNumber } from "../../functions/data-store/data-store-batch-weighing.function";
import { stringIdsToUuids } from "../../functions/string-ids-to-uuids.function";
import { mapToBatchWeighingViewModel } from "../../functions/data-store/data-store-to-viewmodels.function";

export const batchWeighingViewModelConst = (
  batchWeighings: Signal<Record<string, StoreBatchWeighing>>,
  batches: Signal<Record<string, StoreBatch>>
) => {
  return computed(() => {
    const retRecord = {} as Record<string, BatchWeighingViewModel>;
    const bws = batchWeighings();
    recordForEach<StoreBatchWeighing>(bws, (bw) => {
      const batch = getById(batches, bw.batchId);
      const sortedBatchNumbers = getSortedBatchWeighingsByBatchNumber(bw.sectionId, bw.trialId, batchWeighings, batches);
      const adjacentBws = getAdjacentBatchWeighingsByBatchNumber(sortedBatchNumbers, bw.id);
      recordSet(
        retRecord,
        bw.id,
        mapToBatchWeighingViewModel(
          bw.id,
          bw.batchId,
          bw.sectionId,
          bw.trialId,
          batch.number,
          batch.name,
          bw.weighingType,
          bw.gender,
          bw.updateInfo,
          stringIdsToUuids(bw.animalWeighingIds),
          adjacentBws
        )
      );
    });

    return retRecord as Readonly<Record<string, BatchWeighingViewModel>>;
  });
};
